import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    glLoading: false,
    saveGlLoading: false,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    downloadLoading: false,
    bulkUploadLoading: false,
    accountsOpeningData: null,
    glAccountsData: null,
    pagination: null,
    bulkUploadResult: null,
    error: null,
};

export function AccountsOpeningReducer(state = initialState, action) {

    switch (action.type) {
        // Get Accounts Opening List
        case type.GET_ACCOUNTS_OPENING:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                accountsOpeningData: action.payload?.data,
                pagination: action.payload?.pagination,
            }
        case type.GET_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Create Accounts Opening
        case type.CREATE_ACCOUNTS_OPENING:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CREATE_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        case type.CREATE_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        // Update Accounts Opening
        case type.UPDATE_ACCOUNTS_OPENING:
            return {
                ...state,
                updateLoading: true,
                error: null,
            }
        case type.UPDATE_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                updateLoading: false,
            }
        case type.UPDATE_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                updateLoading: false,
            }

        // Delete Accounts Opening
        case type.DELETE_ACCOUNTS_OPENING:
            return {
                ...state,
                deleteLoading: true,
                error: null,
            }
        case type.DELETE_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                deleteLoading: false,
            }
        case type.DELETE_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                deleteLoading: false,
            }

        // Download
        case type.DOWNLOAD_ACCOUNTS_OPENING:
            return {
                ...state,
                downloadLoading: true,
                error: null,
            }
        case type.DOWNLOAD_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                downloadLoading: false,
            }
        case type.DOWNLOAD_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                downloadLoading: false,
            }

        // Bulk Upload
        case type.BULK_UPLOAD_ACCOUNTS_OPENING:
            return {
                ...state,
                bulkUploadLoading: true,
                bulkUploadResult: null,
                error: null,
            }
        case type.BULK_UPLOAD_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                bulkUploadLoading: false,
                bulkUploadResult: action.payload,
            }
        case type.BULK_UPLOAD_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                bulkUploadLoading: false,
            }

        // Get GL Accounts Opening
        case type.GET_GL_ACCOUNTS_OPENING:
            return {
                ...state,
                glLoading: true,
                error: null,
            }
        case type.GET_GL_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                glLoading: false,
                glAccountsData: action.payload,
            }
        case type.GET_GL_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                glLoading: false,
            }

        // Save GL Accounts Opening
        case type.SAVE_GL_ACCOUNTS_OPENING:
            return {
                ...state,
                saveGlLoading: true,
                error: null,
            }
        case type.SAVE_GL_ACCOUNTS_OPENING_SUCCESS:
            return {
                ...state,
                error: null,
                saveGlLoading: false,
            }
        case type.SAVE_GL_ACCOUNTS_OPENING_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                saveGlLoading: false,
            }

        // Clear State
        case type.CLEAR_ACCOUNTS_OPENING_STATE:
            return initialState;

        default:
            return state
    }
}
